import { Button, Grid, GridItem, Separator, Stack, Text, useDisclosure } from "@chakra-ui/react"
import { Form, UI } from "components"
import { API } from "config"
import { toaster } from "config"
import useDistributor from "hooks/useDistributor"
import { useState } from "react"
import OneSignal from "react-onesignal"

export default function Adjusts() {
  return (
    <>
    <UI.Header title="Ajustes" />
    <Grid templateColumns={{ base: '1fr', sm: '1fr', md: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' }} gap={4}>

        <GridItem><Notifications /></GridItem>
        <GridItem><Cache /></GridItem>
        <GridItem><Support /></GridItem>

    </Grid>
    </>
  )
}

function Cache(){

    const [ loading, setLoading ] = useState(false)

    const handleClean = () => {
        setLoading(true)

        localStorage.removeItem('REACT_QUERY_OFFLINE_CACHE')

        setTimeout(() => {
            window.location.reload()
        }, 2000)
    }

    return(
    <UI.Box>
        <Stack gap={4}>
            <Text color="GrayText">Performance:</Text>

            <UI.Lottie animation="cache" options={{ loop: true }} style={{ height: '180px', transform: 'scale(1.2)' }} />

            <Button colorPalette="yellow" loading={loading} loadingText="Limpando cache..." onClick={handleClean}><UI.Icon name="cache" /> Limpar cache do app</Button>
            <Text fontSize="xs" color="fg.muted">Caso esteja com problemas para carregar os dados do seu escritório, tente limpar o cache do seu aplicativo. A página será recarregada em seguida.</Text>
        </Stack>
    </UI.Box>
    )
}

function Notifications(){

    const distributor = useDistributor()
    const [ loading, setLoading ] = useState()
    const optedIn = OneSignal.User.PushSubscription.optedIn

    const toggleOptIn = async () => {
        setLoading(true)
        optedIn ? await OneSignal.User.PushSubscription.optOut() : await OneSignal.User.PushSubscription.optIn()
        setLoading(false)
    }

    const handlePermission = async () => {
        setLoading(true)

        try{
            
            // Solicita permissão nativa
            await OneSignal.Notifications.requestPermission()
            
            // Verifica se a permissão foi negada
            if(!OneSignal.Notifications.permission){
                toaster.create({ title: 'Não foi possível configurar as notificações. Tente novamente.', type: 'warning' })
                setLoading(false)
                return
            }

            // Realiza vínculo
            await OneSignal.login(distributor.data?.id)
            
            // Assina opt-in
            await OneSignal.User.PushSubscription.optIn()

            toaster.create({ title: 'Notificações ativadas com sucesso', type: 'success' })
        }catch(err){
            toaster.create({ title: 'Não foi possível ativar as notificações. Tente novamente.' })
        }

        setLoading(false)
    }

    return(
    <>
    <UI.Box>
        <Stack gap={4}>
            <Text color="GrayText">Notificações:</Text>

            <UI.Lottie animation="notification" options={{ loop: true }} style={{ height: '180px', transform: 'scale(1.2)' }} />
        
            <UI.Show visible={!OneSignal.Notifications.permission}>    
                <Button colorPalette="orange" loading={loading} loadingText="Solicitando permissão..." onClick={handlePermission}><UI.Icon name="notification" /> Ativar notificações</Button>
            </UI.Show>

            <UI.Show visible={OneSignal.Notifications.permission}>    
                <Button disabled colorPalette="orange"><UI.Icon name="check" /> Notificações ativadas</Button>
            </UI.Show>

            <Separator />

            <Form.Checkbox disabled={loading || !OneSignal.Notifications.permission} colorPalette="orange" defaultChecked={optedIn} onChange={toggleOptIn} label="Receber notificações de novidades e promoções." />
        </Stack>
    </UI.Box>
    </>
    )
}

function Support(){

    const distributor = useDistributor()
    const [ loading, setLoading ] = useState(false)

    const handleSupport = () => {
        setLoading('support')

        setTimeout(() => {
            setLoading(false)
            window.open(`https://api.whatsapp.com/send?phone=556299555388`)
        }, 2000)
    }

    const handleChangeOption = async (support_access) => {
        setLoading('option')

        try{
            await API.put('/options', {  field: 'support_remote', value: support_access })
            toaster.create({ title: 'A configuração do suporte foi alterada', type: 'success' })
            distributor.refetch()
        }catch(err){
            toaster.create({ title: 'Não foi possível alterar a configuração', type: 'warning' })
        }

        setLoading(false)
    }
    return(
    <UI.Box>
        <Stack gap={4}>
            <Text color="GrayText">Suporte:</Text>

            <UI.Lottie animation="support" options={{ loop: true }} style={{ height: '180px', transform: 'scale(1.2)' }} />

            <Button colorPalette="green" defaultChecked={distributor.data?.options?.support_remote} loading={loading==='support'} loadingText="Iniciando suporte..." onClick={handleSupport}><UI.Icon name="support" /> Falar com o suporte</Button>

            <Separator />

            {/* <Form.Checkbox disabled={loading==='option'} defaultChecked={distributor.data?.options?.support_remote === true} colorPalette="green" label="Permitir que o suporte acesse meu núcleo para melhor atendimento." onChange={e => handleChangeOption(e.target.checked)} /> */}
        </Stack>
    </UI.Box>
    )
}